import { urlFormatter } from "sb-resp-utils";
export const mapLeagueUrl = (adjustSportsPath, league) => {
    const urlParams = `${urlFormatter.getSportUrl(league.sportName || "")}/${urlFormatter.getLeagueUrl(league.name || "")}`;
    league.linkUrl = adjustSportsPath(urlParams);
    return league;
};
//# sourceMappingURL=mapLeagueUrl.js.map